import { render, staticRenderFns } from "./CustomSlider.vue?vue&type=template&id=5a39d8e0"
import script from "./CustomSlider.vue?vue&type=script&lang=js"
export * from "./CustomSlider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports